var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"nav-menu",attrs:{"to":_vm.isRouterLink ? _vm.to : null,"flat":"","href":_vm.isRouterLink ? null :_vm.to}},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }